var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeDashboardPanel
    ? _c(
        "a",
        {
          staticClass: "header-icon",
          attrs: {
            href: "#",
            title: _vm.titlePanel,
            "data-toggle": "tooltip-city",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.togglePanel.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "svg-inline--fa fa-cube fa-w-16",
              attrs: {
                "aria-hidden": "true",
                focusable: "false",
                "data-prefix": "fas",
                "data-icon": "cube",
                role: "img",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
              },
            },
            [
              _c("path", {
                attrs: {
                  fill: "currentColor",
                  d: "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 34.2l224 84v.3l-224 97.1-224-97.1v-.3l224-84zM32 153.4l208 90.1v224.7l-208-104V153.4zm240 314.8V243.5l208-90.1v210.9L272 468.2z",
                },
              }),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }